module.exports = __webpack_public_path__ + "files/SPIADI2026 - OBSERVA4 - Fiche B2 (Version 2).94b7cdf421926b0b0a824d69d492b2c3.pdf";